import React from 'react';
import {OpenModalsContext} from './openModals';

export function useOpenModals() {
  const context = React.useContext(OpenModalsContext);
  if (context === undefined) {
    throw new Error('useOpenModals must be used within a OpenModalsProvider');
  }
  return context;
}
